export const FORCE_NEW_EXPERIENCE = 'g2w-force-new-experience';
export const RICH_TEXT_ENABLED = 'g2w-rich-text-enabled';
